export const testimonials = [
  { id: 1, text: "Reliable exporter with consistent quality. Shipments always arrive on time." },
  { id: 2, text: "Very smooth experience—from enquiry to delivery. Highly recommended!" },
  { id: 3, text: "Their product quality is exactly as promised. Great packaging and quick response." },
  { id: 4, text: "Professional team, transparent pricing, and excellent support during documentation." },
  { id: 5, text: "One of the best sourcing partners we have worked with in India." }
];
